import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalkWithPathLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 170,
	height: 23.848,
	viewBox: "0 0 170 23.848",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_356",
		"data-name": "Group 356",
		transform: "translate(-16.304 -10.745)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_354",
			"data-name": "Group 354",
			transform: "translate(46.254 16.104)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_353",
				"data-name": "Group 353",
				transform: "translate(0 0)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_363",
						"data-name": "Path 363",
						d: "M127.138,32.418l-3.65,11.256h-3.409l-2.155-6.85-2.251,6.85h-3.409l-3.65-11.256h3.28l2.267,7.187,2.38-7.187h2.926l2.267,7.252,2.364-7.252Z",
						transform: "translate(-108.614 -30.745)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_364",
						"data-name": "Path 364",
						d: "M173.928,43.822v4.84h-2.846V47.536a2.641,2.641,0,0,1-2.573,1.271c-2.09,0-3.248-1.174-3.248-2.685,0-1.608,1.174-2.6,3.875-2.6h1.737c-.048-.884-.643-1.383-1.849-1.383a4.06,4.06,0,0,0-2.364.756l-1.029-2.075a7.323,7.323,0,0,1,3.843-1.013C172.3,39.8,173.928,41.056,173.928,43.822Zm-3.055,2.042v-.756h-1.319c-.981,0-1.334.354-1.334.884,0,.515.418.885,1.142.885A1.505,1.505,0,0,0,170.873,45.864Z",
						transform: "translate(-146.882 -35.734)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_365",
						"data-name": "Path 365",
						d: "M197.921,30.336h3.055V42.267h-3.055Z",
						transform: "translate(-168.946 -29.339)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_366",
						"data-name": "Path 366",
						d: "M217.388,39.212l-.9.917v2.139h-3.055V30.336h3.055v6.255l3.119-3.039h3.618l-3.618,3.73,3.924,4.985h-3.7Z",
						transform: "translate(-179.424 -29.339)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_367",
						"data-name": "Path 367",
						d: "M278.145,32.418l-3.65,11.256h-3.409l-2.155-6.85-2.251,6.85h-3.409l-3.65-11.256h3.28l2.267,7.187,2.379-7.187h2.927l2.267,7.252,2.364-7.252Z",
						transform: "translate(-210.627 -30.745)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_368",
						"data-name": "Path 368",
						d: "M319.488,28.887a1.688,1.688,0,0,1,1.865-1.624,1.654,1.654,0,0,1,1.865,1.576,1.88,1.88,0,0,1-3.73.048Zm.338,2.589h3.055v8.715h-3.055Z",
						transform: "translate(-251.071 -27.263)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_369",
						"data-name": "Path 369",
						d: "M340.145,44.559a4.106,4.106,0,0,1-2.123.5c-2.235,0-3.538-1.093-3.538-3.329V38.8h-1.27V36.519h1.27V34.252h3.055v2.267h1.994V38.8H337.54V41.7a.885.885,0,0,0,.917,1,1.672,1.672,0,0,0,.932-.273Z",
						transform: "translate(-260.344 -31.984)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_370",
						"data-name": "Path 370",
						d: "M367.471,37.282v4.985h-3.055V37.781c0-1.254-.547-1.785-1.431-1.785-.981,0-1.737.611-1.737,2.058v4.213h-3.055V30.336h3.055v4.02a3.779,3.779,0,0,1,2.621-.949C365.911,33.407,367.471,34.581,367.471,37.282Z",
						transform: "translate(-277.218 -29.339)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_371",
						"data-name": "Path 371",
						d: "M417.7,36.582c0,2.557-1.929,4.149-5,4.149h-1.962v2.942h-3.184V32.418H412.7C415.77,32.418,417.7,34.01,417.7,36.582Zm-3.216,0c0-1.045-.66-1.656-1.978-1.656h-1.769v3.3h1.769C413.824,38.223,414.484,37.611,414.484,36.582Z",
						transform: "translate(-310.563 -30.745)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_372",
						"data-name": "Path 372",
						d: "M450.021,43.822v4.84h-2.846V47.536a2.64,2.64,0,0,1-2.573,1.271c-2.09,0-3.248-1.174-3.248-2.685,0-1.608,1.174-2.6,3.875-2.6h1.737c-.048-.884-.643-1.383-1.849-1.383a4.058,4.058,0,0,0-2.364.756l-1.029-2.075a7.323,7.323,0,0,1,3.843-1.013C448.4,39.8,450.021,41.056,450.021,43.822Zm-3.055,2.042v-.756h-1.318c-.981,0-1.335.354-1.335.884,0,.515.418.885,1.142.885A1.5,1.5,0,0,0,446.966,45.864Z",
						transform: "translate(-333.398 -35.734)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_373",
						"data-name": "Path 373",
						d: "M478.118,44.559a4.105,4.105,0,0,1-2.122.5c-2.235,0-3.537-1.093-3.537-3.329V38.8h-1.27V36.519h1.27V34.252h3.055v2.267h1.994V38.8h-1.994V41.7a.885.885,0,0,0,.916,1,1.673,1.673,0,0,0,.933-.273Z",
						transform: "translate(-353.552 -31.984)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_374",
						"data-name": "Path 374",
						d: "M505.444,37.282v4.985h-3.055V37.781c0-1.254-.546-1.785-1.431-1.785-.981,0-1.736.611-1.736,2.058v4.213h-3.055V30.336h3.055v4.02a3.779,3.779,0,0,1,2.621-.949C503.884,33.407,505.444,34.581,505.444,37.282Z",
						transform: "translate(-370.426 -29.339)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_375",
						"data-name": "Path 375",
						d: "M528.974,58.206a1.833,1.833,0,0,1,3.666,0,1.833,1.833,0,0,1-3.666,0Z",
						transform: "translate(-392.59 -46.95)",
						fill: "#67d2df"
					})
				]
			})
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_355",
			"data-name": "Group 355",
			transform: "translate(16.304 10.745)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_376",
					"data-name": "Path 376",
					d: "M17.036,25.025a17.916,17.916,0,0,0,7.55-6.59,36.089,36.089,0,0,0,3.368-7.689A11.92,11.92,0,0,0,16.619,25.384,1.593,1.593,0,0,1,17.036,25.025Z",
					transform: "translate(-16.304 -10.745)",
					fill: "#67d2df"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_377",
					"data-name": "Path 377",
					d: "M40.238,47.493c-2.657,3.6-5.463,5.883-9.731,6.007a14.376,14.376,0,0,1-6.025-1.072A11.906,11.906,0,0,0,45.615,43.71C45.2,43.7,42.955,43.812,40.238,47.493Z",
					transform: "translate(-21.829 -33.014)",
					fill: "#67d2df"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_378",
					"data-name": "Path 378",
					d: "M26.168,48.5c7.049-.215,8.961-5.718,11.521-7.69a7.209,7.209,0,0,1,4.265-1.7c-.06-.35-.129-.7-.218-1.036a9.36,9.36,0,0,0-5.689,1.4c-2.7,1.956-3.694,3.846-7.677,5.614a15.552,15.552,0,0,1-9.148.7,11.925,11.925,0,0,0,.744,1.454A14.91,14.91,0,0,0,26.168,48.5Z",
					transform: "translate(-18.275 -29.192)",
					fill: "#67d2df"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_379",
					"data-name": "Path 379",
					d: "M29.22,25.641c.618,1.23,4.868-.114,6.693-1.247,2.584-1.605,5.243-5.136,8.3-5.969a13.017,13.017,0,0,1,3.673-.456A11.93,11.93,0,0,0,37.74,10.814a37.181,37.181,0,0,1-2.8,7.565C32.486,23.489,28.9,25,29.22,25.641Z",
					transform: "translate(-25.016 -10.792)",
					fill: "#67d2df"
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(SvgWalkWithPathLogo);
export { ForwardRef as ReactComponent };
